import { PaymentStatus } from "@/common/enum/payment-status";
import { PaymentType } from "@/common/enum/payment-type";
import { getBankName } from "@/common/util/get-display-bank";
import { FileCopyOutlineIcon } from "@/components/icon/FileCopyOutlineIcon";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Strong } from "@/components/typography/Body14Strong";
import { PaymentDto } from "@/types/dto/payment-dto";

const AccountInfo = ({ payment }: { payment: PaymentDto }) => {
  const handleCopyClick = async () => {
    try {
      await navigator.clipboard.writeText(accountInfo);
      window.confirm("계좌번호가 복사되었습니다.");
    } catch (error) {
      console.error("Failed to copy: ", error);
      window.confirm("계좌번호 복사에 실패했습니다.");
    }
  };

  const getAccountInfo = (payment: PaymentDto) => {
    switch (payment.paymentMethod) {
      case PaymentType.PALT: // Pay Later
        return "신한은행 140-014-327272 아카라라이프(주)";
      case PaymentType.PAVC: // Virtual Account
        return `${getBankName(payment.extraDataVC?.bankcode.slice(-2)) ?? ""} ${payment.extraDataVC?.account
          }`;
      case PaymentType.PABK: // Bank Transfer
        return `${getBankName(payment.extraDataDeposit?.bank_code)} ${payment.extraDataDeposit?.account
          }`;
      default:
        return "";
    }
  };

  const accountInfo = getAccountInfo(payment);
  return (
    <>
      {payment.status === PaymentStatus.PENDING && (
        <div
          className="flex gap-[4px] items-center cursor-pointer"
          onClick={handleCopyClick}
        >
          <Body14Strong>입금계좌</Body14Strong>
          <Body14Regular>{accountInfo}</Body14Regular>
          <FileCopyOutlineIcon size={16} color="text-grayscale-contrast-60" />
        </div>
      )}
      {payment.status === PaymentStatus.PENDING && (
        <Body14Regular className="text-semantic-text-error-primary">
          {payment.paymentMethod === PaymentType.PAVC ? (
            <>
              {new Date(new Date(payment.createdAt).getTime() + 24 * 60 * 60 * 1000).toLocaleDateString('ko-KR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}까지 미입금 시 자동취소 됩니다.
            </>
          ) : (
            '입금 기한이 지날 경우 패널티를 부여받습니다.'
          )}
        </Body14Regular>
      )}
    </>
  );
};

export default AccountInfo;
